/**
 * Warnings list
 */
export enum WARNING_MESSAGE {
  SETUP_BUTTONS = 'Please setup buttons for your component or use this.modalService.notify(...):',
}
